import Logs from '@/api/logs/logs'

const logs = new Logs()

const logsModule = {
  namespaced: true,
  state: {
    items: [],
    item: null,
    total: 0,
  },
  getters: {
    items(state) {
      return state.items
    },
    item(state) {
      return state.item
    },
    total(state) {
      return state.total
    },
  },

  mutations: {
    SET_ITEMS: (state, logs) => {
      state.items = logs
    },
    SET_TOTAL_LOGS: (state, total) => {
      state.total = total
    },

    SET_ITEM: (state, school) => {
      state.item = school
    },
  },

  actions: {
    listLogs({ commit }, query) {
      return new Promise((resolve, reject) => {
        logs.listLogs(query).then(response => {
          commit('SET_ITEMS', response)
          // commit("SET_TOTAL_LOGS", response.meta.total);
          resolve(response)
        })
      })
    },
  },
}

export default logsModule
